import {useMutation, useQueryClient} from "@tanstack/react-query";
import {ErrorClassifierService} from "../../../../../services/error_classifier.service";
import {IErrorClassifierErrorKey} from "../../../../../store/errorClassifier/types";

export function useDeleteErrorKey() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => ErrorClassifierService.removeErrorKey(id),

        onMutate: async (id) => {
            await queryClient.cancelQueries({queryKey: ["keyErrorClassifierErrorKeys"]});

            const previousKeys = queryClient.getQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"]);

            queryClient.setQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"], (old) =>
                old?.filter((key) => key.id !== id) ?? []
            );

            return {previousKeys};
        },

        onError: (err, id, context) => {
            if (context?.previousKeys) {
                queryClient.setQueryData(["keyErrorClassifierErrorKeys"], context.previousKeys);
            }
        },
    });
}
